import { Row, Breadcrumb, Col, Form, Input, Button, Typography } from "antd";
import { Link, useHistory } from "react-router-dom";
import { Colors } from "../../../theme";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { useGlobal } from "../../../store/index";
import { useEffect, useState } from "react";
import API_KEY from "../../../api";
import { randomString } from "../../../utils/randomString";
import ProductActions from "redux/actions/productActions";
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
import { getData,sendData } from "store/firebase/methods";

const { Title, Text } = Typography;

function CreateCollectionForm({actions}) {
  const [form] = Form.useForm();
  const [userData, setUserData] = useState(null);
  // const [global, setGlobal] = useGlobal();
  const history = useHistory();
  const [loading, setLoading] = useState(false)
  // const { createCollection } = global;

  useEffect(() => {
    getData().then((res) => {
      console.log("res",res);
      if(res){
        sendData([])
      }
    }).catch((err) => {console.log(err)});

    // if (localStorage.getItem("selectedProducts")) {
    //   localStorage.removeItem("selectedProducts");
    // }
  }, []);

  useEffect(() => {
    const userId = JSON.parse(localStorage.getItem("userId"));
    API_KEY.URL.get(API_KEY.path.manufacturer)
      .then((res) => {
        setUserData(res?.data?.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // // route to another page
  // useEffect(() => {
  //   if (createCollection?.id) {
  //     history.push(`select-products/${createCollection?.id}`);
  //   }
  // }, [createCollection, history]);

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  // handle form submit
  const onFinish = (values) => {
    var org = localStorage.getItem("org")
    const orgId =  JSON.parse(org).id;
    setLoading(true)
    API_KEY.URL.post(API_KEY.path.collections, {
      ...values,
      exporter_name: userData?.name,
      logo: userData?.logo,
      banner_image: userData?.banner,
      collection_link: randomString(7),
      manufacturer: orgId
    })
      .then((response) => {
        if (response.status === 200) {
          setLoading(false)
          history.push(`select-products/${response?.data?.data?.id}`);
          localStorage.setItem("new",true);
          localStorage.removeItem("selectedProducts");
          actions.setProducts([]);

        }
      })
      .catch((error) => {
        setLoading(false)
        console.log(error);
      });
    // setGlobal.collections.createCollection(values);
  };

  // handle form finish
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/" onClick={() => {
              gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_HOME);
            }}> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create Catalogue</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
      <Row>
        <Col xl={{ span: 12, offset: 6 }}>
          <Row>
            <Title level={2} style={{ fontFamily: "Gilroy", margin: 0 }}>
              Create a new catalogue
            </Title>
          </Row>
          <Row>
            <Text style={{ color: Colors.gray, fontSize: "1rem" }}>
             Enter the following details
            </Text>
          </Row>
          <Form
            form={form}
            name="create-collection"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <Row style={{ marginTop: "2.5rem" }}>
              <Col xl={{ span: 24 }}>
                <Form.Item
                  className="form-label"
                  label="Buyer Company"
                  name="buyer_name"
                  {...formItemLayout}
                  rules={[{ required: true, message: "Enter company name" }]}
                >
                  <Input size="large" placeholder="Full name of the Buying company/Agency"
                    onClick={() => {
                      gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.CREATE_COLLECTION_BUYER_COMPANY_NAME);
                    }}
                  />
                </Form.Item>
                <Form.Item
                 className="form-label"
                  label="Name of the catalogue"
                  name="collection_name"
                  {...formItemLayout}
                  rules={[{ required: true, message: "Eg. Spring Collection" }]}
                >
                  <Input placeholder="Catalogue name" size="large"
                    onClick={() => {
                      gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.CREATE_COLLECTION_CATALOGUE_NAME);
                    }}
                  />
                </Form.Item>
                <Form.Item
                 className="form-label"
                  label="Buyer Email ID (optional)"
                  name="email_ids"
                  
                  {...formItemLayout}
                  rules={[{ type: "email", required: false, message: "Enter valid email" }]}
                >
                  <Input placeholder="Enter buyer email"  size="large"
                    onClick={() => {
                      gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.CREATE_COLLECTION_BUYER_EMAIL);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row justify="end" style={{marginTop:'2rem'}}>
              <Col span={6}>
                <Button
                  style={{ width: "100%" }}
                  type="primary"
                  htmlType="submit"
                  size="large"
                  onClick={() => {
                    gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.CREATE_COLLECTION_NEXT_BUTTON);
                  }}
                  loading={loading}
                >
                 Next
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      setProducts: ProductActions.setProducts,
    },
    dispatch
  ),
});

export default connect(null, mapDispatchToProps)(CreateCollectionForm);